<template>
  <div class="verfif" v-if="VAQdialogVisible">
    <el-dialog
      v-model="isSms"
      :append-to-body="true"
      :close-on-click-modal="false"
      class="sms-dialog"
      title="短信验证码"
      width="514px">
      <div class="title" :class="errorText ? 'error-text' : ''">{{errorText ? errorText : '本操作需要手机短信验证'}}</div>
      <div class="iphone">
        <i class="iconfont icon-biaoqianguanli-" />
        <span>{{phone}}</span>
      </div>
      <div class="img-sms">
        <el-input  placeholder="图片验证码" class="left-input" v-model="captcha" />
        <img class="right-img" @click="getCaptcha" v-if="randomNumber" :src=" $apiurl + '/openapi/captcha?captchatoken=' + randomNumber" />
      </div>
      <div class="img-sms">
        <el-input placeholder="请输入验证码" class="left-input" v-model="smsCaptcha"></el-input>
          <a class="sms-obtain" @click="smsCountdownFun" v-loading="smsLoading">{{smsCountdown ? (smsCountdown + '秒后重新获取验证码') : '获取验证码'}}</a>
      </div>
      <div class="sms-yes-button" @click="smsYesButton" v-loading="buttonLoading">确定</div>
      <a class="sms-close-button" @click="isSms = false">取消</a>
    </el-dialog>

    <div class="verifi-div" v-show="isSmsView">
      <img src="https://bigdata.topeti.com/PCRepository/defaultSvg/NoTask.svg" class="verifi-img" />
      <div class="verifi-text">本应用需验证后才能访问</div>
      <div class="verifi-button" @click="openProcess">开始验证</div>
    </div>

    <upIphone ref="upIphones" @yesRetIphone="retUpIphone" />
  </div>
</template>

<script>
  import upIphone from '@/components/common/upIphone.vue'
  import { mobileGetapprovalvalidcode, openapiGetappvalidate } from '@/port/clientSide/workbench'

  export default {
    name: "smsVerifiction",
    components: {
      upIphone
    },
    props:{
      exportType:{
        type:String,
        default:''
      }
    },
    data() {
      return {
        isSms: false,
        VAQdialogVisible: false,  // 全局是否显示
        isSmsView: false, // 是否需要显示未验证不关闭
        randomNumber: '', // 图形验证码token
        phone: '',  // 手机号
        captcha: '',  // 图片验证码
        smsCaptcha: '', // 短信验证码
        smsCountdown: 0,
        smsTimeout: null, // 倒计时存放
        errorText: '',  // 错误提示输出
        buttonLoading: false, // 按钮请求加载中
        smsLoading: false,  // 获取验证按钮
      }
    },
    watch: {
      VAQdialogVisible(val) {
        if (!val) {
          if (this.smsTimeout) clearTimeout(this.smsTimeout);
          this.isSmsView = false;
          this.isSms = false;
          this.phone = '';
        }
      },
      isSms(val) {
        console.log(this.exportType);
        if (!val) {
          this.getCaptcha();
          if (this.captcha) this.captcha = '';
          this.smsCaptcha = '';
          this.smsCountdown = 0;
          this.errorText = '';
          this.smsTimeout = null;
          this.smsLoading = false;
          this.$emit('close')
        }
      }
    },
    methods: {
      getCaptcha () {
        this.randomNumber = (Math.random() * 10).toString().slice(-6);
      },
      // 确定验证
      smsYesButton() {
        if (this.buttonLoading) return false;
        if (!this.smsCaptcha) {
          this.errorText = '短信验证码不能为空！';
          return false
        }
        if (!this.captcha) {
          this.errorText = '图片验证不能为空';
          return false;
        }
        let obj = {
          validcode: this.smsCaptcha,
          captchatoken: this.randomNumber,
          captcha: this.captcha,
          phone: this.phone
        };
        this.buttonLoading = true;
        openapiGetappvalidate(obj).then(res => {
          console.log(res);
          if (res.code === 0) {
            this.$emit('smsRefersh',this.exportType);
            this.VAQdialogVisible = false;
          } else {
            this.errorText = res.msg;
          }
          this.buttonLoading = false;
        }).catch(err => {
          this.buttonLoading = false;
          console.log(err)
        })
      },
      // 再次打开验证
      openProcess() {
        if (this.phone) {
          this.isSms = true;
        } else {
          this.onUpIphone();
        }
      },
      // 获取验证码倒计时
      smsCountdownFun() {
        if (this.smsLoading) return false;
        if (!this.captcha) {
          this.errorText = '图片验证码不能为空！';
          return false;
        }
        if (this.smsCountdown === 0) {
          let obj = {
            phone: this.phone,
            captchatoken: this.randomNumber,
            captcha: this.captcha
          };
          this.smsLoading = true;
          mobileGetapprovalvalidcode(obj).then(res => {
            console.log('获取验证码', res)
            if (res.code === 0) {
              this.errorText = '';
              this.smsCountdown = 60;
              this.smsTimeoutFun();
            } else {
              this.errorText = res.msg;
            }
            this.smsLoading = false;
          }).catch(err => {
            this.smsLoading = false;
            console.log(err)
          })
        }
      },
      smsTimeoutFun() {
        let self = this;
        this.smsTimeout = setTimeout(function(){
          if (self.smsCountdown > 0) self.smsCountdown -= 1;
          if (self.smsCountdown > 0) {
            self.smsTimeoutFun();
          }
        }, 1000);
      },
      // 打开短信验证窗口
      openSmsVer(e, info) {
        if (e) this.phone = e;
        if (info && info.isSmsView) this.isSmsView = true;
        if (!this.randomNumber) this.getCaptcha();
        this.VAQdialogVisible = true;
        this.isSms = true;
      },
      // 打开绑定手机窗口
      onUpIphone () {
        this.VAQdialogVisible = true;
        let val = {
          title: '绑定手机',
          bottom: '确定绑定',
          origin: 'user'
        };
        this.$nextTick(() => {
          console.log('帮i的那个', this.$refs);
          this.$refs.upIphones.showDialog(val);
        })
      },
      // 手机绑定窗口返回
      retUpIphone(e) {
        console.log('手机绑定窗口返回');
        this.phone = e;
        if (!this.randomNumber) this.getCaptcha();
        this.isSms = true;
      },
      // 需要绑定手机号提示
      iphoneBind(e) {
        this.VAQdialogVisible = true;
        if (e.isSmsView) this.isSmsView = true;
        let self = this;
        this.$confirm('本操作需要短信验证，您尚未绑定手机，是否先去绑定？', '提示', {
          confirmButtonClass:'el-button--yeprimary',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.onUpIphone();
        }).catch(() => {

        });
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/assets/style/clientSide/smsVerifi.scss";
</style>
